import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Box, Menu, MenuItem, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { DateRangePicker, SingleDatePicker } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import "./range.css";
import moment from "moment";
import GlobalButton from "../button";

function CustomRangePicker({
  stackProps,
  iconProps,
  rangeProps,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  handleFilterDate,
}) {
  const [focusedInput, setFocusedInput] = useState(null);
  const [focused, setFocused] = useState(null); // For single date picker focus
  const [anchorEl, setAnchorEl] = useState(null); // Menu anchor element
  const [datePickerMode, setDatePickerMode] = useState("range"); // Default to range

  // Handle date changes for range
  const handleDatesChange = ({ startDate, endDate }) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  // Handle single date change
  const handleSingleDateChange = (date) => {
    setStartDate(date);
    setEndDate(date); // You can keep both start and end date the same for single selection
  };

  // Handle menu open
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Handle menu close
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // Handle menu item click
  const handleMenuItemClick = (mode) => {
    setDatePickerMode(mode);
    handleMenuClose(); // Close the menu after selection
  };


  return (
    <Stack
      p={"8px"}
      gap={1.5}
      direction={"row"}
      alignItems={"center"}
      bgcolor={"secondary.light"}
      {...stackProps}
    >
      <Stack direction={"row"} alignItems={"center"} gap={1}>
        <Stack
          justifyContent={"center"}
          alignItems={"center"}
          position={"relative"}
        >
          <CalendarMonthIcon
            htmlColor={"secondary.dark"}
            sx={{ fontSize: "1.1rem", cursor: "pointer", ...iconProps }}
            onClick={handleMenuClick} // Open menu on calendar icon click
          />
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={() => handleMenuItemClick("single")}>
              Single Date Picker
            </MenuItem>
            <MenuItem onClick={() => handleMenuItemClick("range")}>
              Date Range Picker
            </MenuItem>
          </Menu>
        </Stack>
      </Stack>

      <Stack direction={"row"} alignItems={"center"} gap={1}>
        {datePickerMode === "single" ? (
          // Single Date Picker
          <SingleDatePicker
            date={startDate}
            onDateChange={handleSingleDateChange}
            focused={focused}
            onFocusChange={({ focused }) => setFocused(focused)}
            noBorder
            isOutsideRange={() => false}
            displayFormat={"DD/MM/YYYY"}
            hideKeyboardShortcutsPanel
            id="single_date_picker"
            {...rangeProps}
          />
        ) : (
          // Date Range Picker
          <DateRangePicker
            startDate={startDate}
            startDateId="your_start_date_id"
            endDate={endDate}
            endDateId="your_end_date_id"
            onDatesChange={handleDatesChange}
            focusedInput={focusedInput}
            onFocusChange={(focusedInput) => setFocusedInput(focusedInput)}
            noBorder
            displayFormat={"DD/MM/YYYY"}
            isOutsideRange={() => false}
            hideKeyboardShortcutsPanel
            customArrowIcon={"-"}
            {...rangeProps}
          />
        )}
      </Stack>

      <GlobalButton
        variant={"custom_gradient"}
        title={"Filter"}
        handleClickBtn={handleFilterDate}
        style={{
          width: "auto",
          height: 35,
          borderRadius: "12px",
        }}
      />
    </Stack>
  );
}

export default CustomRangePicker;
